import * as React from 'react';
import { InfoText } from 'ui';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { experienceTransferTranslation } from '../constants';
import { ExperienceTransferState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import styles from './list.scss';

export type OperationsListProps = DefaultContainerProps
  & ExperienceTransferState
  & typeof actionCreators;

class OperationsListComponent extends React.PureComponent<OperationsListProps> {
  public static statePath: string = STATE.experienceTransfer;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { operations, sharedState, translation,
      loadOperationsList, updateOperations, displayError } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <div className={styles.header}>
        <MainGridContainer>
          <h1 className={styles.headerTitle}>
            {translation.configure_operations_transfer}
          </h1>
          <InfoText
            visible={true}
            text={translation.configure_operations_info_text} />
        </MainGridContainer>
      </div>
      <ListRenderer
        listState={operations}
        loadList={loadOperationsList}
        updateOperations={updateOperations}
        translation={translation} />
    </ListWrapper>;
  }
}

const container = containerFactory(OperationsListComponent, actionCreators, undefined, experienceTransferTranslation);

export { container as OperationsList };
